module.exports = __webpack_public_path__ + "static/img/pro3.b595d0e7.png";